
























import { LabelSize } from '@getaccept/lib-ui';
import { nanoid } from 'nanoid';
import { defineComponent, computed } from '@vue/composition-api';

export default defineComponent({
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  setup() {
    const uuid = nanoid();

    const restrictedLockId = computed(() => `restricted-checkbox-${uuid}`);
    const restrictedLabelId = computed(() => `restricted-checkbox-label-${uuid}`);

    return {
      LabelSize,
      restrictedLockId,
      restrictedLabelId,
    };
  },
});
